import { FieldActionOnValuesFunction } from '../types';
import { DeclarationSubmissionModel } from '../../api/models/eOTRegistration';
import { standardTitleOptions } from '../title';

export const declarationSubmission: FieldActionOnValuesFunction<DeclarationSubmissionModel> = {
    eotDeclarantTitle: standardTitleOptions,
};
